import { Box, Stack, Typography, useTheme } from "@mui/material";
import { format, parseISO } from "date-fns";
import { ActivityItem } from "@/modules/lead-page/dtos/index-v2";

const BrokerShowingInfo = ({ item }: { item: ActivityItem }) => {
  const theme = useTheme();

  const brokerName = item.formData?.brokerName as string | undefined;
  const tenantName = item.formData?.tenantName as string | undefined;
  const showingDate = item.formData?.showingDate as string | undefined;

  const formattedShowingDate = showingDate
    ? format(parseISO(showingDate), "d MMM yyyy")
    : null;

  const rows: { label: string; value: string | null }[] = [
    { label: "Broker", value: brokerName ?? null },
    { label: "Showing date", value: formattedShowingDate },
    { label: "Tenant", value: tenantName ?? null },
  ];

  return (
    <Stack spacing={theme.nawy.spacing.xxs}>
      {rows.map(
        (row) =>
          row.value && (
            <Box
              key={row.label}
              sx={{ display: "flex", gap: theme.nawy.spacing.xxs }}
            >
              <Typography
                sx={{
                  color: theme.nawy.colors.semantic.text.primary,
                  ...theme.nawy.typography.english.variants.body.sm.semibold,
                  minWidth: "fit-content",
                }}
              >
                {row.label}:
              </Typography>
              <Typography
                sx={{
                  color: theme.nawy.colors.semantic.text.secondary,
                  ...theme.nawy.typography.english.variants.body.sm.regular,
                }}
              >
                {row.value}
              </Typography>
            </Box>
          )
      )}
    </Stack>
  );
};

export default BrokerShowingInfo;
